import * as angular from 'angular';
import { SharedServicesModule } from '~/modules/mode-shared-services';
import { FixedScrollDirective } from './fixed_scroll';
import { ExtendedUibDropdownMenuDirective } from './uib_dropdown_menu_extend';
import { RadioDropdownDirective } from './radio_dropdown';

export const DirectivesModule = angular
  .module('mode.directives', [SharedServicesModule])
  .directive('fixedScroll', FixedScrollDirective)
  .directive('uibDropdownMenu', ExtendedUibDropdownMenuDirective)
  .directive('radioDropdown', RadioDropdownDirective).name;
